import { render } from "./HelpCenter.vue?vue&type=template&id=56be605f&scoped=true"
import script from "./HelpCenter.vue?vue&type=script&lang=js"
export * from "./HelpCenter.vue?vue&type=script&lang=js"

import "./HelpCenter.vue?vue&type=style&index=0&id=56be605f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56be605f"]])

export default __exports__